import type React from 'react';
import { getLinkToFreshSignup } from '@farmersdog/tosa/src/utils/getLinkToSignupFlow';
import { PATH_SIGNUP_ME } from '@farmersdog/constants/paths';
import {
  Box,
  Picture,
  generateSourcesForPicture,
  useViewport,
} from '@farmersdog/corgi-x';
import { useTrackedSectionRef } from '../../../../hooks/useTrackedSections';
import { ExtendedButton } from '../ExtendedButton';
import styles from './Pricing.module.css';

import startingAtPng from './assets/startingAt.png';
import { CtaTrackerV2, HomepageRedesignSections } from '../CtaTrackerV2';
import { ExtendedText } from '../ExtendedText';

const pricingHeadlineId = 'pricing-headline';

const sources = generateSourcesForPicture({
  mobileSources: {
    png: startingAtPng,
  },
  desktopSources: {
    png: startingAtPng,
  },
});

export const PricingSection: React.FC = () => {
  const viewport = useViewport();
  const isMobile = !viewport.md;

  const linkToSignup = getLinkToFreshSignup(PATH_SIGNUP_ME);

  const pricingRef = useTrackedSectionRef<HTMLDivElement>(
    HomepageRedesignSections.Pricing
  );

  return (
    <Box aria-labelledby={pricingHeadlineId} className={styles.wrapper}>
      <div className={styles.container} ref={pricingRef}>
        <div className={styles.content}>
          <ExtendedText
            variant={isMobile ? 'heading-28' : 'heading-36'}
            id={pricingHeadlineId}
            color="white"
            bottomSpacing="md"
            align={isMobile ? 'center' : 'left'}
            bold
            as="div"
          >
            Starting at $2 /day
          </ExtendedText>
          <ExtendedText
            variant="heading-22"
            color="white"
            as="div"
            bottomSpacing={{ xs: 'md', md: 'lg' }}
            className={styles.subtitle}
          >
            Get fresh food for your dog,
            <br />
            24/7 customer support,
            <br />
            and free home delivery.
          </ExtendedText>
          <CtaTrackerV2
            type="select"
            moduleLevel={1}
            moduleName={HomepageRedesignSections.Pricing}
          >
            <ExtendedButton
              variant="bordered-white"
              size="md"
              type="link"
              to={linkToSignup}
              className={styles.desktopButton}
            >
              Shop Now
            </ExtendedButton>
          </CtaTrackerV2>
        </div>
        <Picture
          sources={sources}
          alt="The Farmers Dog box composition"
          className={styles.image}
        />
        <CtaTrackerV2
          type="select"
          moduleLevel={1}
          moduleName={HomepageRedesignSections.Pricing}
        >
          <ExtendedButton
            type="link"
            to={linkToSignup}
            variant="bordered-white"
            size="md"
            className={styles.mobileButton}
          >
            Shop Now
          </ExtendedButton>
        </CtaTrackerV2>
      </div>
    </Box>
  );
};
